import { NgClass, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import {
	AfterViewInit,
	Component,
	Input,
	OnInit,
	Optional,
	Self
} from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ICustomControl } from 'src/shared/models/form.model';
import { NgxMaskDirective } from 'ngx-mask';
import { IonIcon } from "@ionic/angular/standalone";
import { ValidationComponent } from "../validation/validation.component";
import { addIcons } from 'ionicons';
import { eyeOffOutline, eyeOutline } from 'ionicons/icons';

@Component({
	selector: 'vl-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
	imports: [IonIcon, NgClass, NgIf, NgFor, TranslatePipe, NgSwitch, NgSwitchCase, NgxMaskDirective, ValidationComponent],
})
export class InputComponent implements OnInit, ControlValueAccessor, AfterViewInit {
	@Input() control: ICustomControl;
	@Input() submitted = false;
	@Input() minLength = 0;
	@Input() maxLength = 50;
	@Input() clazz = '';
	@Input() isInline = false;
	@Input() disabled = false;
	visibilityMap: { [key: string]: boolean } = {};
	public value: any;

	constructor(
		// Retrieve the dependency only from the local injector,
		// not from parent or ancestors.
		@Self()
		// We want to be able to use the component without a form,
		// so we mark the dependency as optional.
		@Optional()
		public formControl: NgControl) {
		if (this.formControl) {
			this.formControl.valueAccessor = this;
		}
		addIcons({eyeOffOutline, eyeOutline})
	}
	togglePasswordVisibility(fieldId: string) {
		this.visibilityMap[fieldId] = !this.visibilityMap[fieldId];
	}
	
	  // Check if the password is visible for the given field
	isPasswordVisible(fieldId: string): boolean {
		return this.visibilityMap[fieldId] || false;
	}

	ngOnInit(): void {
		// console.log('this.control', this.control.mask, this.control.prefix);
		if (this.control.mask !== undefined && this.control.prefix !== undefined) {
			this.control.maskType = 2;
		} else if (this.control.mask !== undefined) {
			this.control.maskType = 1;
		} else {
			this.control.maskType = 0;
		}
	}

	preventSpace(event: KeyboardEvent, control: ICustomControl): void {
		if (((event.key === ' ') || (event.key === '.')) && control.showVisibleToggle) {
			event.preventDefault();
		}
	}

	public ngAfterViewInit(): void {

	}

	onInputChange(event) {
		const newValue: boolean = event.target.checked;
		if (newValue !== this.value) {
			this.value = newValue;
			this.onChange(newValue);
		}
	}

	/**
	 * Write form disabled state to the DOM element (model => view)
	 */
	setDisabledState(isDisabled: boolean): void {
		this.disabled = isDisabled;
	}

	public registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	public registerOnTouched(fn: any): void {
		this.control.focused = false;
		this.onTouched = fn;
	}

	public writeValue(value: any): void {
		this.value = value;
	}

	onChange = event => {
	};
	onTouched = () => {
	};

	focused(control, event) {
		control.focused = true
		let total = 0;
		let container = null;

		const _rec = (obj) => {

			total += obj.offsetTop;
			const par = obj.offsetParent;
			if (par && par.localName !== 'ion-content') {
				_rec(par);
			} else {
				container = par;
			}
		}
		_rec(event.target);
		if (container) {
			container.scrollToPoint(0, total - 50, 400);
		}
	}
}
